import React, { useContext } from "react";
import { ThemeContext } from "../ThemeContext";
import "../../../Styles/AdminDashbord/appDashboard.css";
// import "../../../Styles/AdminDashbord/entete.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";

const Entete = ({ title }) => {
  const { theme } = useContext(ThemeContext);
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const currentTime = new Date().toLocaleTimeString();
  return (
    <div className="entete-dashboard">
      <div
        className="border border-1 shadow-sm row p-2 g-2
       d-flex align-items-center"
        style={{
          backgroundColor: theme === "dark" ? "black" : "white",
        }}
      >
        <div className="col-12 col-md-6">
          <h4
            className="name_entreprise_dashboard mb-0"
            style={{ color: theme === "dark" ? "white" : "black" }}
          >
            {title}
          </h4>
        </div>

        <div className="col-6 col-md-2 mt-2 mt-md-0">
          <h5
            className="petit_titre d-flex align-items-center justify-content-center justify-content-md-end mb-0"
            style={{ color: theme === "dark" ? "white" : "black" }}
          >
            <FontAwesomeIcon icon={faArrowsRotate} className="me-1" /> Rafraîchir
          </h5>
        </div>

        <div className="col-6 col-md-4 mt-2 mt-md-0">
          <h6
            className="entete-date petit_title d-flex align-items-center justify-content-center bg-light p-2 mb-0 text-center"
          >
            {formattedDate} {currentTime}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Entete;